import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Avatar from "./views/Avatar.vue";
import Complete from "./views/Complete.vue";
import Home from "./views/Home.vue";
import Survey from "./views/Survey.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      component: Avatar,
      name: "avatar",
      path: "/avatar"
    },
    {
      beforeEnter: (to, from, next) => {
        if (isIncompleteGuard()) return next("/");
        next();
      },
      component: Complete,
      name: "complete",
      path: "/complete"
    },
    {
      component: Home,
      name: "home",
      path: "/"
    },
    {
      beforeEnter: (to, from, next) => {
        if (isIncompleteGuard()) return next("/");
        next();
      },
      component: Survey,
      name: "survey",
      path: "/survey"
    },
  ]
});

/**
 * Returns true if there is neither an image nor avatar ID set in state.
 */
function isIncompleteGuard(): boolean {
  return !store.getters.image && !store.getters.avatar;
}
